// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomInputMask_container__1RPHK","label":"CustomInputMask_label__AlnQ7","input":"CustomInputMask_input__21EBT"};